import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import { setToken } from '../services/authToken';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);

    try {
      const { data } = await authAPI.login(email, senha);
      if (data.usuario.tipo !== 'admin') {
        setErro('Essa conta não tem acesso ao painel administrativo.');
        return;
      }
      setToken(data.token);
      sessionStorage.setItem('userLoggedIn', 'true');
      sessionStorage.setItem('userEmail', data.usuario.email);
      navigate('/');
    } catch (err) {
      setErro(err.response?.data?.error || 'Email ou senha incorretos!');
      setTimeout(() => setErro(''), 3000);
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-side-grid" />

      <div className="login-card">
        <div className="login-brand">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M15 2L27 9V21L15 28L3 21V9L15 2Z" stroke="#F28787" strokeWidth="2"/>
            <path d="M15 2V28M3 9L27 21M27 9L3 21" stroke="#F28787" strokeWidth="1"/>
          </svg>
          <span>SIGE</span>
        </div>

        <h1>Acesso administrativo</h1>

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-field">
            <label htmlFor="email">Email</label>
            <div className="login-input-group">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 6h16v12H4z" strokeLinejoin="round"/><path d="m4 7 8 6 8-6" strokeLinejoin="round"/></svg>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                autoFocus
              />
            </div>
          </div>

          <div className="login-field">
            <label htmlFor="senha">Senha</label>
            <div className="login-input-group">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>
              <input
                type={mostrarSenha ? 'text' : 'password'}
                id="senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="••••••••"
                required
                style={{ paddingRight: 40 }}
              />
              <button type="button" className="login-toggle-senha" onClick={() => setMostrarSenha((v) => !v)} aria-label="Mostrar senha">
                {mostrarSenha ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 3l18 18"/><path d="M10.6 10.6a2 2 0 0 0 2.8 2.8"/><path d="M6.6 6.7C4.5 8 3 10 2 12c1.8 3.6 5.5 7 10 7 1.6 0 3.1-.4 4.4-1.1M9.9 4.2A10.4 10.4 0 0 1 12 4c4.5 0 8.2 3.4 10 7-.6 1.2-1.4 2.4-2.4 3.5"/></svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>
                )}
              </button>
            </div>
          </div>

          {erro && (
            <div className="login-erro">
              <span>⚠️ {erro}</span>
            </div>
          )}

          <button type="submit" className="login-btn" disabled={carregando}>
            {carregando && <span className="login-spinner" />}
            {carregando ? 'Entrando…' : 'Entrar'}
          </button>
        </form>

        <p className="login-footnote">© 2026 SIGE. Todos os direitos reservados.</p>
      </div>
    </div>
  );
}

export default Login;
